import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { User } from './../../common/models/user';
import { Template } from './../../common/models/template';
import { Product } from '../../common/models/product';

import { TemplateService } from '../../landing/services/template.service';
import { ProductService } from '../../shopping-cart/services/product.service';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { SessionManager } from '../../common/helpers/session-manager';
import { AppLoggingService } from '../../common/services/AppLogging.service';
import { promotions } from '../../common/config/promotions';
import * as _ from 'lodash';
import { NgSwitch } from '@angular/common';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  user = new User();
  template = new Template();
  product: Product[] = [];
  promotionProducts: Product[] = [];
  customerid: string;
  promoCode: string;
  productListCode: string;

  constructor(private templateService: TemplateService, private productService: ProductService,
    private authenticationService: AuthenticationService, private activatedRoute: ActivatedRoute,
    private router: Router, private sessionManager: SessionManager, private log: AppLoggingService, ngSwitch: NgSwitch) {

  }


  ngOnInit() {
    //2020.08.21 - cleared local storage
    this.sessionManager.clearPromoCode();
    
    // get the url appended customer id and the promocode
    this.activatedRoute.params.subscribe((params: Params) => {

      this.promoCode = params['promocode'];
      this.customerid = params['customerid'];
      
      console.log("Starting webshop, promocode="+this.promoCode + ", customerId="+this.customerid);
      if (this.promoCode) {
        this.sessionManager.setPromoCode(this.promoCode);
      }else{
        //2020.08.21 - set version 9 as default promo code // doesnt change even if the template is changed??/!!!#$# 
        this.sessionManager.setPromoCode('versjon9ogmedlemskap');
      }

      //}else{
      //  this.sessionManager.setPromoCode("templateFREEversjon9");
     // }

      this.getCustomerDetails(this.customerid);
      this.getTemplateByPromoCode();

    });

  }


  getTemplateByPromoCode() {

    const storedPromoCode = this.sessionManager.getPromoCode();
    
    // if promo code not null load the second template (not default template)
    // and get all the product and promotion details then calculate the promotion
    this.template = this.templateService.getTemplateByPromoCode(storedPromoCode);
    // if (storedPromoCode) {
    //   this.template = this.templateService.getTemplateByPromoCode(storedPromoCode);

    // } else {
    //   this.template = this.templateService.getTemplateByPromoCode('');
    // }
  }


  getCustomerDetails(customerId: any) {

    if (typeof customerId !== 'undefined' && customerId !== '0') {
      this.authenticationService.getCustomerDetails(this.customerid).subscribe(data => {
      });
    }
    else{
      localStorage.removeItem('currentUser');
    }
  }


  addItemToShoppingCart() {

    this.authenticationService.getCurrentUser().subscribe((response: any) => {

      if (response.emailAddress !== null) {
              this.productService.getProductsByProductCode().subscribe(data => {
                this.router.navigate(['/register']);
              });
            }
    });
    // this.authenticationService.getCurrentUser().subscribe((response: any) => {

    //   if (response.emailAddress !== null) {
    //     this.authenticationService.CheckAlreadyPaidUser(response.purchasedProducts)
    //       .subscribe((result: any) => {
    //         const isPaid = result;

    //         if (isPaid === true) {

    //           this.log.errorCode = 'WSSE161';
    //           this.router.navigate(['alert']);
    //         } else {
    //           this.router.navigate(['/register']);
    //           this.productService.getProductsByProductCode().subscribe(data => {
    //           });
    //         }
    //       });
    //   }
    // });
  }

  // When default template loaded user should be able to go normal process
  DefaultTemplateShoppingCart() {

    this.sessionManager.setPromoCode('slektogdata');
    this.addItemToShoppingCart();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/landing/home/home.component.ts